import { TFunction } from "i18next";

import { CRITERION_LABEL_KEYS, ScoreIssue } from "./scoreIssues";

/**
 * Renders an issue's message. The engine hands over a key and raw params; the
 * fixed criteria are named by their key, so their label is translated here,
 * and a nameless row reads "Untitled" rather than an empty string.
 */
export const issueText = (t: TFunction, issue: ScoreIssue): string => {
	const params: Record<string, string | number> = { ...issue.message.params };
	const untitled = t("leadScoring.shell.untitled");

	for (const field of ["name", "segment", "persona"]) {
		if (field in params && params[field] === "") {
			params[field] = untitled;
		}
	}

	if (typeof params.criterion === "string" && CRITERION_LABEL_KEYS[params.criterion]) {
		params.criterion = t(`leadScoring.${CRITERION_LABEL_KEYS[params.criterion]}`);
	}

	return t(`leadScoring.shell.issues.${issue.message.key}`, params);
};
